module.exports = __webpack_public_path__ + "static/img/weather_002.ec7b50e3.svg";